// extracted by mini-css-extract-plugin
export default {"root":"etkXDolMGZPY03hcYo9U"};